export default __webpack_public_path__ + "static/media/lunch.7602560d.svg";